// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  font-size: 250%;
  text-align: center;
  color: var(--text-color);
}

#table-container {
  width: 100%;
  overflow-x: scroll;
}

table {
  width: 100%;
}

.search-container {
  display: flex;
  justify-content: center;
}

.mat-form-field {
  border-radius: 25px; /* Adjust the value for roundness */
  overflow: hidden;
}

.mat-form-field .mat-input-element {
  border-radius: 25px;
  padding: 8px 12px; /* Optional: adjust padding */
}

.mat-form-field label {
  padding: 0 8px; /* Optional: adjust label padding */
}

.search-container {
  display: flex;
  align-items: center;
  position: relative;
}

.info-popup {
  position: absolute;
  background-color: #e4e4e4;
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 100;
  top: 138px;
  left: 78%;
  transform: translateX(-50%);
  width: 250px;
  text-align: center;
}

.info-popup.ng-trigger {
  opacity: 1;
  visibility: visible;
}

@media (max-width: 600px) {
  .info-popup {
    top: 50px;
    left: 50%;
    transform: translateX(-50%);
    width: 200px;
  }
}
mat-label {
  color: var(--text-color);
}

::placeholder {
  color: var(--text-color);
}

td,
th {
  width: 25%;
}

.info-button {
  position: relative;
  transform: translateY(-20%);
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/app/components/company-dashboard/company-dashboard.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,kBAAA;EACA,wBAAA;AACJ;;AAEA;EACI,WAAA;EACA,kBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AACA;EACI,aAAA;EACA,uBAAA;AAEJ;;AACA;EACI,mBAAA,EAAA,mCAAA;EACA,gBAAA;AAEJ;;AACA;EACI,mBAAA;EACA,iBAAA,EAAA,6BAAA;AAEJ;;AACA;EACI,cAAA,EAAA,mCAAA;AAEJ;;AACA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AAEJ;;AACE;EACE,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,kBAAA;AAEJ;;AACE;EACE,UAAA;EACA,mBAAA;AAEJ;;AACE;EACE;IACI,SAAA;IACA,SAAA;IACA,2BAAA;IACA,YAAA;EAEN;AACF;AACA;EACI,wBAAA;AACJ;;AAEA;EACI,wBAAA;AACJ;;AAEA;;EAEI,UAAA;AACJ;;AAEA;EACI,kBAAA;EACA,2BAAA;EACA,UAAA;AACJ","sourcesContent":["h1 {\r\n    font-size: 250%;\r\n    text-align: center;\r\n    color: var(--text-color);\r\n}\r\n\r\n#table-container {\r\n    width: 100%;\r\n    overflow-x: scroll;\r\n}\r\n\r\ntable {\r\n    width: 100%;\r\n}\r\n.search-container{\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.mat-form-field {\r\n    border-radius: 25px; /* Adjust the value for roundness */\r\n    overflow: hidden;\r\n}\r\n\r\n.mat-form-field .mat-input-element {\r\n    border-radius: 25px;\r\n    padding: 8px 12px; /* Optional: adjust padding */\r\n}\r\n\r\n.mat-form-field label {\r\n    padding: 0 8px; /* Optional: adjust label padding */\r\n}\r\n\r\n.search-container {\r\n    display: flex;\r\n    align-items: center;\r\n    position: relative; \r\n  }\r\n  \r\n  .info-popup {\r\n    position: absolute;\r\n    background-color: #e4e4e4;\r\n    padding: 15px;\r\n    border-radius: 5px;\r\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\r\n    z-index: 100;\r\n    top: 138px; \r\n    left: 78%;\r\n    transform: translateX(-50%); \r\n    width: 250px;\r\n    text-align: center;\r\n}\r\n  \r\n  .info-popup.ng-trigger {\r\n    opacity: 1;\r\n    visibility: visible;\r\n  }\r\n\r\n  @media (max-width: 600px) {\r\n    .info-popup {\r\n        top: 50px; \r\n        left: 50%;\r\n        transform: translateX(-50%);\r\n        width: 200px;  \r\n    }\r\n}\r\n\r\nmat-label{\r\n    color: var(--text-color);\r\n}\r\n\r\n::placeholder{\r\n    color: var(--text-color);\r\n}\r\n\r\ntd,\r\nth {\r\n    width: 25%;\r\n}\r\n\r\n.info-button {\r\n    position: relative;\r\n    transform: translateY(-20%);\r\n    z-index: 2; \r\n  }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
